<template>

	<div class="flex items-start p-2 justify-content-between">
		<div>
			<div class="flex items-center">
				<div><img src='https://assets.newspark.ca/2/v5/gfx/uploadwizard.png' style="height:64px"></div>
				<div class="ml-2 text-2xl">{{title}}</div>
			</div>
		</div>
		<div v-if="url!=''">
			<Sheet>
			<SheetTrigger> <Button>Preview</Button>
			</SheetTrigger>
			<SheetContent  style="max-width: 50vw"> 
			<SheetHeader>
			<SheetTitle> Preview</SheetTitle>
			<SheetDescription>
			<website-display :url="'https://'+url" :refresh="step"/>
			</SheetDescription>
			</SheetHeader>
			</SheetContent>
			</Sheet>

		</div>
		<div v-else>
			<Sheet>
			<SheetTrigger> <Button>Preview</Button>
			</SheetTrigger>
			<SheetContent  style="max-width: 50vw"> 
			<SheetHeader>
			<SheetTitle> Preview</SheetTitle>
			<SheetDescription>
			<div class="border p-5"  v-if="typeof settings !='undefined'"  :class="'background-color:'+settings.design.colour_body">
				<header class="header sticky top-0 bg-card shadow-md flex items-center justify-between px-8 py-2 z-10">
					<!-- logo -->
					<h1 class="w-4/12 p-3">
						<img v-if="typeof settings !='undefined'" :src="settings.global.assets_headerImage" :alt="settings.global.pageTitle" class='w-32 mx-auto block' />
					</h1>

					<!-- navigation -->

					<!-- buttons --->
					<div class="w-4/12 flex justify-end">
						<div class="text-right">
							<h3 class="text-sky-500"><a href="#" >dave@newspark.io</a></h3>
						</div>
					</div>
				</header>

				<div class="grid grid-cols-2 gap-4 mt-4">
					<div v-for="(field, index) in formFields" :key="index" :class="{'col-span-2': field.width==1}">
						<div v-if="field.type!='Checkbox' && field.type!='Text Area' && field.type!='Group'" class="mt-1 text-left">
							<Label :for="'field' + index">{{ field.label }}</Label>
							<Input v-if="field.type === 'Text'" type="text"  :required="field.required" autocomplete="off"/>
							<Input v-else-if="field.type === 'Email'" type="email"  :required="field.required" autocomplete="off"/>
							<Input v-else-if="field.type === 'Password'" type="password"  :required="field.required" autocomplete="off"/>
							<Input v-else-if="field.type === 'Number'" type="number"  :required="field.required" autocomplete="off"/>
						</div>
						<div v-else-if="field.type=='Text Area'" class="mt-1 text-left">
							<Label :for="'field' + index">{{ field.label }}</Label>
							<Textarea class="form-control" :required="field.required"/>
						</div>
						<div v-else-if="field.type=='Group'" class="mt-1 text-left">
							<Label :for="'field' + index">{{ field.label }}</Label>
							<Select >
								<SelectTrigger>
								<SelectValue :placeholder="field.label" />
								</SelectTrigger>
								<SelectContent>
								<SelectItems>Group will be listed here.</SelectItems>
								</SelectContent>
							</Select>   

						</div>
						<div v-else class="mt-1 text-left">
							<Switch/>
							<Label for="flexCheckDefault">
								{{ field.label }}
							</Label>
						</div>
						<p class="form-text text-muted small pl-2 text-left"><div v-html="field.helpText"></div></p>
					</div>
					<div v-if="showUpload" class="mt-2 col-span-2 relative flex min-h-[100px] items-center justify-center rounded-md border border-dashed border-sky-800 p-8 text-center">
						Upload Box
					</div>
				</div>
			</div>

			</SheetDescription>
			</SheetHeader>
			</SheetContent>
			</Sheet>

		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from '@/components/ui/select'
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle, SheetTrigger, } from '@/components/ui/sheet'
import WebsiteDisplay from '@/components/WebsiteDisplay.vue';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Switch } from '@/components/ui/switch'
import { Textarea } from '@/components/ui/textarea'

import { Button } from '@/components/ui/button'
export default defineComponent({
	name: 'Header',
	components: {
		Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue,
		Label,
		Textarea,
		Input,
		Switch,
		Button,
		WebsiteDisplay,
		Sheet,
		SheetContent,
		SheetDescription,
		SheetHeader,
		SheetTitle,
		SheetTrigger,
	},
	props: {
		showUpload: {
			type: Boolean,
			required: false,
		},
		title: {
			type: String,
			required: true,
		},
		url: {
			type: String,
			required: false,
		},
		formFields: {
			type: Object,
			required: false,
		},
		settings: {
			type: Object,
			required: false,
		},
		step: {
			type: Number,
			required: true,
		},
	},
});
</script>

<style scoped>
/* Add any additional styles if necessary */
</style>

